<div *ngIf="!isLoading; else loading" class="landing-section">
  <div class="section-visual">
    <img
      *ngIf="!isVideo"
      [src]="section?.media?.url + '?w=' + (index === 0 ? '1920' : '1128')"
      [alt]="section?.media?.placeholderImage?.description" />
    <kp-video-player
      *ngIf="isVideo"
      [altText]="section?.media?.placeholderImage?.description"
      [analyticsPageName]="analyticsPageName"
      [url]="section?.media?.url"
      [image]="section?.media?.placeholderImage?.url"></kp-video-player>
    <div class="hero-only">
      <a routerLink="." fragment="second-section">
        <p>Learn more</p>
        <svg-icon class="more-arrow" src="/assets/icons/chevron-right-nocircle.svg"></svg-icon>
      </a>
    </div>
  </div>
  <div class="section-content">
    <h2>{{ section?.title }}</h2>
    <kui-rich-text [richText]="section?.rawBody"></kui-rich-text>
    <button
      class="button button-pill button-reverse"
      data-test="get-started-section-button"
      (click)="getStartedClicked.emit({ index: index, title: section?.title, contentId: section?.contentId })">
      {{ section?.buttonText }}
    </button>
  </div>
</div>
<a id="second-section" *ngIf="hero"></a>
<ng-template #loading>
  <div class="landing-section">
    <div class="section-content">
      <kp-shimmer class="w25 shimmer-header"></kp-shimmer>
      <kp-shimmer class="w75 shimmer-body"></kp-shimmer>
      <kp-shimmer class="w15 shimmer-button"></kp-shimmer>
    </div>
  </div>
</ng-template>
